import { connect } from 'react-redux';
import View from './ValidationErrorsView';
import {
  errorsSelector,
  hasErrorsSelector,
} from './ValidationErrorsSelector';
import {
  isNumeric,
  createCustomPropType,
} from '../../../js/app/react/validators';
import { setErrors } from '../WhatIfsActions';

const mapStateToProps = (state, ownProps) => ({
  errors: errorsSelector(state, ownProps),
  hasErrors: hasErrorsSelector(state, ownProps),
});

const mapDispatchToProps = dispatch => ({
  close: clientId => (event) => {
    event.stopPropagation();
    dispatch(setErrors(clientId, []));
  },
});

const ValidationErrorsContainer = connect(mapStateToProps, mapDispatchToProps)(View);

ValidationErrorsContainer.propTypes = {
  clientId: createCustomPropType(isNumeric).isRequired,
};

export default ValidationErrorsContainer;
